import { render, staticRenderFns } from "./CarePlanIcon.vue?vue&type=template&id=56249eb0"
import script from "./CarePlanIcon.vue?vue&type=script&lang=js"
export * from "./CarePlanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports